<template>	
		<div class="survey-post">
				
				<div class="survey-post-top">
					<div class="deleteSurvey">
						<button class="del-btn" v-if="isAdmin"  @click="openDeleteModal(surveyData.survey.quoteReference)"></button>
					</div>
					<deleteSurveyConfirmModal :quoteReference="surveyData.survey.quoteReference" quoteStatus="Open Quotations"/>
					<div class="survey-post-top-attributes col md-7">	
						<div class="quoteNumber">
							<span class="survey-post-title">Quote Number</span>
							<span class="survey-post-entry">{{surveyData.survey.quoteReference}}</span>
						</div>
						<div class="clientName" v-if="isAdmin">
							<span class="survey-post-title">Client</span>
							<span class="survey-post-entry">{{surveyData.user.alias}}</span>
						</div>
						<div class="Company" v-if="isAdmin">
							<span class="survey-post-title">Company</span>
							<span class="survey-post-entry">{{surveyData.user.companyName}}</span>
						</div>
						<div class="areas">
							<span class="survey-post-title">Areas</span>
							<span class="survey-post-entry">{{surveyData.areas.length}}</span>
						</div>
						<div class="totalarea">
							<span class="survey-post-title">Total Area</span>
							<span class="survey-post-entry">{{surveyData.survey.totalArea | currency('', 0)}}sqm</span>
						</div>
						<div class="totalarea">
							<span class="survey-post-title">Total Cost</span>
							<span class="survey-post-entry">{{surveyData.survey.quotePrice | currency('£')}}</span>
						</div>
					</div>

					<div class="survey-post-top-controls col md-5">	
						<div class="admin__download" v-if="isAdmin">
							<a download :href="surveyData.survey.quoteFilesUrl" class="btn btn-small">&nbsp;</a>
						</div>
						<div class="open-toggle">
							<button class="btn btn-small view__toggle" @click="openClose">
								{{toggled === surveyData.survey.quoteReference ? 'Close' : 'View'}}
							</button>
						</div>

						<!-- <button class="btn btn-small" @click="openClose" v-if="isAdmin">
							{{toggled === surveyData.survey.quoteReference ? 'Close' : 'Open'}}
						</button> -->
						<router-link 
							
							:to="{ path : '/create/checkout/' + surveyData.survey.quoteReference}" 
						>
							<button class="btn btn-small primary">See Quote</button>
						</router-link>
						
						<a download :href="surveyData.survey.quotePDFUrl" v-if="!isAdmin">
							<button class="btn btn-small dl">
								Download
							</button>
						</a>
					</div>
					
					<div class="clearfix"></div>
				</div>

				<div class="survey-post-body" v-show="toggled == surveyData.survey.quoteReference">	
					<div class="survey-post-area" v-for="(area, i) in surveyData.areas" :key="i">
						<div class="indexer">
							{{ i + 1}} of {{surveyData.areas.length}}
						</div>
						<div class="map-viewer"  v-if="isAdmin">
							<button class="btn btn-small"  @click="openPreviewArea(area.areaId)">
								Preview Area
							</button>
							<previewStaticMapModal :key="''+i" :areaTitle="area.areaTitle" :areaDesc="area.areaDescription" :areaId="area.areaId" :coordinates="area.kmlCoordinates"/>
						</div>
						<div class="area-top">	
							<p class="areaId">Area Id - {{area.areaId}}</p>
							<div class="survey-post__title">{{area.areaTitle | truncate(70)}}</div>
						</div>
						<div class="area-bottom">	
							<div class="totalArea">	
								<span class="area-bot__title">Total Area</span>
								<span class="area-bot__val">{{area.areaSquared.toLocaleString('en')}}</span>
							</div>
							<div class="userUpload">	
								<span class="area-bot__title">Land</span>
								<span class="area-bot__val">{{area.serviceOption1 === true ? 'Yes' : 'No'}}</span>
							</div>
							<div class="userUpload">	
								<span class="area-bot__title">Building</span>
								<span class="area-bot__val">{{area.serviceOption2 === true ? 'Yes' : 'No'}}</span>
							</div>
							<div class="userUpload">	
								<span class="area-bot__title">Drone</span>
								<span class="area-bot__val">{{area.serviceOption3 === true ? 'Yes' : 'No'}}</span>
							</div>
							<div class="userUpload">	
								<span class="area-bot__title">Utilities</span>
								<span class="area-bot__val">{{area.serviceOption4 === true ? 'Yes' : 'No'}}</span>
							</div>
							<div class="userUpload">	
								<span class="area-bot__title">File Upload</span>
								<span class="area-bot__val">{{area.userUpload === true ? 'No' : 'Plan uploaded'}}</span>
							</div>						

							<div class="additionalDetails">	
								<span class="area-bot__title">Additional Details</span>
								{{area.additionalDetails[0] == "" ? 'None' : 'Yes'}}
							</div>
						</div>
					</div>
					<!-- <div class="further-admin-only-details" v-if="isAdmin">	
						<hr>
							<div class="emailAddress">	
								<span>Email Address :</span>
								<span>{{surveyData.user.email}}</span>
							</div>
							<div class="phoneNumberOne" v-if="surveyData.user.phoneNumber">	
								<span>Primary Phone number :</span>
								<span>{{surveyData.user.phoneNumber}}</span>
							</div>
							<div class="phoneNumberTwo" v-if="surveyData.user.phoneNumberTwo">	
								<span>Secondary Phone number : </span>
								<span>{{surveyData.user.phoneNumberTwo}}</span>
							</div>
							<hr>
					</div> -->
					<div class="client-details" v-if="isAdmin">	
						<div class="client-details__title">Client Contact Info</div>
							<div class="client-details__email">	
								<span class="client-details__desc">Email Address:</span>
								<span>{{surveyData.user.email}}</span>
							</div>
							<div class="client-details__phone" v-if="surveyData.user.phoneNumber">	
								<span class="client-details__desc">Primary Phone number :</span>
								<span>{{surveyData.user.phoneNumber}}</span>
							</div>
							<div class="client-details__phone" v-if="surveyData.user.phoneNumberTwo">	
								<span class="client-details__desc">Secondary Phone number : </span>
								<span>{{surveyData.user.phoneNumberTwo}}</span>
							</div>
					</div>
					
					<div class="updateJobCost" v-if="isAdmin">
						<div class="client-details__title">Amend quotation</div>
						<div class="col md-5 updateJobCost__new-cost"><input type="number" placeholder="Job Cost (£)" v-model="uploadData.quotePrice"></div>
						<div class="col md-4 updateJobCost__upload"><input type="file" @change="handleFileChange" name="quotePdf"></div>
						<div class="col md-3"><button class="btn btn-small" :disabled="uploadData.quotePrice === surveyData.survey.quotePrice || forceDisableSendQuoteBtn" @click="updateQuotation">Send Revised Quotation</button></div>
						<div class="clearfix"></div>
					</div>
				
				</div>

		</div>
</template>

<script>	
import previewStaticMapModal from '../Modals/previewStaticMapModal';
import deleteSurveyConfirmModal from '../Modals/deleteSurveyConfirmModal';
export default {
	props : ['surveyData', 'toggled', 'isAdmin'],
	components : {
		previewStaticMapModal : previewStaticMapModal,
		deleteSurveyConfirmModal : deleteSurveyConfirmModal
	},
	data(){
		return {
			forceDisableSendQuoteBtn : false,
			uploadData : {
				quotePrice : this.surveyData.survey.quotePrice,
				quotePdf : undefined
			}
		}
	},
	methods : {
		openClose(){

			this.$emit('openCloseToggle', this.surveyData.survey.quoteReference);
		},
		openPreviewArea(areaId){
			this.$store.commit('openModal', 'previewStaticMapModal' + areaId)
		},
		openDeleteModal(quoteReference){
			this.$store.commit('openModal', 'deleteSurveyConfirmModal' + quoteReference);
		},
		handleFileChange(e){
			var file = e.target.files[0]; 
			this.uploadData.quotePdf = file;
		},
		updateQuotation(){
			this.forceDisableSendQuoteBtn = true;
	
			let data = Object.assign({}, this.uploadData);
			if(data.quotePdf === undefined){
				delete data.quotePdf
			}
			this.$store.dispatch('updateSurveyQuote', {quoteReference : this.surveyData.survey.quoteReference, data : data})
			.then((response) => {
				this.$toasted.clear()
				this.forceDisableSendQuoteBtn = false;
				if(response.confirmation === 'success'){
					this.$toasted.success("Survey updated!", {
			            theme: 'bubble',
			            position: 'bottom-center',
			            duration: 5000
			        })
				} else {
					this.$toasted.error(response.message, {
			            theme: 'bubble',
			            position: 'bottom-center',
			            duration: 5000
			        })
				}
			})
			.catch((err) => {
				this.$toasted.clear()
				this.forceDisableSendQuoteBtn = true;

				this.$toasted.error(err.message, {
			        theme: 'bubble',
			        position: 'bottom-center',
			        duration: 5000
			    })
			})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/common/Dashboard/QuotationOpenPost.vue